import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import LTIconButton from '../LTIconButton/index.js';
import Success from '../../icons/success.js';
import Copy from '../../icons/copy.js';
import { copyTextToClipboard } from '../../utils/functions.js';

var CopyContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n"], ["\n  align-items: center;\n  display: flex;\n"])));
var LTCopyToClipboard = function LTCopyToClipboard(_a) {
  var _b = _a.copyAriaLabel,
    copyAriaLabel = _b === void 0 ? "Copy to clipboard" : _b,
    _c = _a.copiedAriaLabel,
    copiedAriaLabel = _c === void 0 ? "Copied to clipboard" : _c,
    onCopy = _a.onCopy,
    textToCopy = _a.textToCopy,
    _d = _a.useNavigator,
    useNavigator = _d === void 0 ? false : _d;
  var _e = useState(false),
    isCopied = _e[0],
    setIsCopied = _e[1];
  var copyBtnRef = useRef();
  var copyText = function copyText(event) {
    var _a;
    event.stopPropagation();
    event.preventDefault();
    // Adds ability to perform custom action on copy.
    if (onCopy) {
      onCopy(event);
    } else {
      if (useNavigator) {
        (_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(textToCopy);
      } else {
        copyTextToClipboard(textToCopy);
      }
    }
    setIsCopied(true);
    setTimeout(function () {
      setIsCopied(false);
      if (copyBtnRef && copyBtnRef.current) {
        copyBtnRef.current.focus();
      }
    }, 1000);
  };
  return /*#__PURE__*/React.createElement(CopyContainer, null, isCopied ? /*#__PURE__*/React.createElement(LTIconButton, {
    "aria-label": copiedAriaLabel,
    icon: Success,
    size: LTIconButton.Size.SMALL,
    variant: LTIconButton.IconButtonVariants.INVISIBLE
  }) : /*#__PURE__*/React.createElement(LTIconButton, {
    "aria-label": copyAriaLabel,
    icon: Copy,
    onClick: copyText,
    ref: copyBtnRef,
    size: LTIconButton.Size.SMALL,
    variant: LTIconButton.IconButtonVariants.INVISIBLE
  }));
};
var templateObject_1;

export { LTCopyToClipboard as default };
